<template>
    <div id="app">
        <keep-alive>
            <router-view :key="$route.fullPath"  v-if='$route.meta.keepAlive'/>
        </keep-alive>
        <router-view :key="$route.fullPath"  v-if='!$route.meta.keepAlive'/>
    </div>
</template>

<script>

import webConfig from "@/api/config";

export default {
    name: 'App',
    mounted() {
        document.getElementById("web_title").innerText = webConfig.appName;
        document.getElementById("web_logo").href = webConfig.logoUrl;
    }
}
</script>

<style>
body {
    overflow: hidden;
    //padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #333333;
}

</style>
